/* 周瑜傳・第 3 章上半：夷陵（建安十三年，208）
 * 長江在南邊。夷陵是江北的小城（東、南兩座城門），曹仁的兵分三營圍城，城外立了高樓往城裡射箭。
 * 周瑜、呂蒙的船隊在東南的江岸上岸。城北是山，三條險道穿過山口往北通到當陽、江陵（敵人敗走的路）。 */
export const CITY = { x: 2000, y: 2300, hw: 420, hh: 320 };
const T = 32, G = 110, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { e: [E, CITY.y], s: [CITY.x, S] };
export const LAND = [6600, 3450], PASSES = [[1300, 950], [3000, 950], [4700, 950]], EXIT_Y = 260;
export const TOWERS = [[CITY.x, N - 230], [E + 260, CITY.y - 60], [CITY.x + 60, S + 230]];
export const SIEGE = [[CITY.x - 80, N - 520], [E + 620, CITY.y + 80], [CITY.x + 380, S + 520]]; // 曹軍三營
export default {
  id: 'zhouyu_yiling', name: '夷陵', W: 8000, H: 4800, seed: 2081,
  bases: [LAND, [CITY.x, CITY.y]],
  walls: [
    [CITY.x, N, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh],
    [(CITY.x - G + Wx) / 2, S, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, S, (E - CITY.x - G) / 2 + T, T],
    [E, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [E, (S + CITY.y + G) / 2, T, (S - CITY.y - G) / 2],
  ],
  rivers: [{ pts: [[-100, 4250], [3000, 4220], [6000, 4270], [8100, 4230]], hw: 470, fords: [] }],
  roads: [
    { pts: [LAND, [5200, 3000], [3700, 2500], GATES.e, [CITY.x, CITY.y]], w: 140 },
    { pts: [[1700, 1700], [1300, 1300], PASSES[0], [1300, EXIT_Y]], w: 110 },
    { pts: [[3300, 2400], [3000, 1500], PASSES[1], [3000, EXIT_Y]], w: 110 },
    { pts: [[4300, 2700], [4700, 1600], PASSES[2], [4700, EXIT_Y]], w: 110 },
  ],
  rocks: PASSES.flatMap(([x, y]) => [[x - 330, y, 230, 170], [x + 330, y, 230, 170]]).concat([[6400, 1600, 400, 200], [7300, 2600, 300, 160]]),
  woods: 0.6,
  sight: 0.7,
  clearings: [[CITY.x, CITY.y, 900], [LAND[0], LAND[1], 420], [SIEGE[1][0], SIEGE[1][1], 420], [SIEGE[0][0], SIEGE[0][1], 380], [SIEGE[2][0], SIEGE[2][1], 380]].concat(PASSES.map(([x, y]) => [x, y + 250, 160])),
  tents: [
    { x: SIEGE[0][0], y: SIEGE[0][1], n: 4, r: 300, col: '#3b5a99', flag: '曹' },
    { x: SIEGE[1][0], y: SIEGE[1][1], n: 5, r: 340, chief: true, col: '#3b5a99', flag: '曹' },
    { x: SIEGE[2][0], y: SIEGE[2][1], n: 4, r: 300, col: '#3b5a99', flag: '曹' },
  ],
  grass: [[5600, 2200, 220, 90], [3800, 3300, 240, 100]],
};
